<template>
  <div class="ecommerce-more-panel">
    <div class="component-background" @click="close" />
    <div class="wrapper no-scrollbar">
      <span class="close">
        <i class="fa fa-chevron-right fa-lg" @click="close" />
      </span>
      <!-- <div class="invisible has-text-centered">
        <i class="fa fa-circle" @click="triggerShowInfo" />
      </div> -->

      <div class="main-list no-scrollbar">
        <div @click="goto(`/commerce_home/${business.id}`)">
          <i class="fa fa-home fa-lg" />
          <p>{{ $t("ecommerce.manager") }}</p>
        </div>
        <div @click="goto(`/commerce_page/set-hours`)">
          <i class="far fa-clock fa-lg" />
          <p>{{ $t("ecommerce.shop-hours") }}</p>
        </div>
        <div @click="goto(`/commerce_page/menu-product-list`)">
          <i class="fa fa-list fa-lg" />
          <p>{{ $t("ecommerce.edit-menu") }}</p>
        </div>
        <div @click="emit('showSettings')">
          <i class="fa fa-cog fa-lg" />
          <p>{{ $t("settings") }}</p>
        </div>
        <!-- <div @click="emit('showShare')">
          <i class="fa fa-link fa-lg" />
          <p>{{ $t("Share Shop") }}</p>
        </div> -->
        <div @click="emit('showShare')">
          <i class="fa fa-qrcode fa-lg" />
          <p>{{ $t("ecommerce.share-shop") }}</p>
        </div>
        <!-- <div v-if="hasMembership" class="column" @click="showMembers = true"> -->
        <div @click="emit('showMembers')">
          <i class="far fa-address-card fa-lg" />
          <p>{{ $t("commerce.members") }}</p>
        </div>
        <!-- <div
          class="has-text-grey"
          @click="warningToast('Analytics coming soon')"
        >
          <i class="far fa-chart-bar fa-lg" />
          <p>{{ $t("Analytics") }}</p>
        </div>
        <div class="has-text-grey" @click="warningToast('Billing coming soon')">
          <i class="fa fa-file-invoice fa-lg" />
          <p>{{ $t("commerce.billing") }}</p>
        </div> -->
        <div @click="emit('showNotifications')">
          <i
            class="far fa-bell fa-lg"
            :class="{ 'has-text-danger': !$store.state.notificationToken }"
          />
          <!-- !$store.getters.getNotificationToken -->
          <p>{{ $t("driver.notifications") }}</p>
        </div>
        <div @click="openSupport">
          <i class="fa fa-headset fa-lg" />
          <p>{{ $t("profile.support") }}</p>
        </div>
      </div>

      <!-- End -->
      <div class="has-text-centered" style="margin-bottom: 10px">
        <i class="far fa-window-minimize has-text-grey" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EcommerceMorePanel",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    // business() {
    //   return this.$store.state.selectedBusiness;
    // },
    role() {
      // console.log("z role", this.z);
      return this.$store.getters.getCommerceAgentRole;
    },
    business() {
      return this.role.business;
    },
    isSuper() {
      return this.$store.getters.isSuperUser;
    },
    notificationsClass() {
      if (!this.$store.state.user) return null;
      if (this.$store.getters.getNotificationToken) {
        return "has-text-success";
      }
      return "has-text-danger";
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    openSupport() {
      // setTimeout(() => this.contactFBMessengerSupport(), 500);
      setTimeout(() => this.contactMerchantSupport(), 500);
      var msg = "Opening TUK Support chat...";
      this.infoToast(msg);
    },
    emit(cmd) {
      this.$emit(cmd);
      this.close();
    },
  },
};
</script>

<style scoped>
.hidden {
  display: none;
}
.component-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 4;
}
.wrapper {
  position: absolute;
  top: 0;
  right: 0;
  height: 100vh;
  min-width: 80px;
  backdrop-filter: blur(8px);
  background-color: rgba(255, 255, 255, 0.85);
  /* background-color: #333;
  color: white; */
  padding-bottom: 10px;
  padding-top: 14px;
  padding-left: 10px;
  padding-right: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35);
  z-index: 5;
  /* border-top-left-radius: 25px;
  border-bottom-left-radius: 25px; */
  /* overflow-x: auto; */
  /* white-space: nowrap; */
}

.column {
  /* display: inline-block; */
  /* width: 100px; */
  padding: 0 0;
  margin-bottom: 15px;
}
.column img {
  height: 60px;
}
.column p {
  margin-top: -5px;
}
.close {
  position: absolute;
  left: 4px;
  top: 0;
  padding: 8px;
}
.invisible {
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0px;
  padding: 25px;
  margin-bottom: 15px;
  opacity: 0.1;
  /* margin-right: 2px; */
}
.status {
  width: 100%;
  position: absolute;
  bottom: 0px;
  padding: 8px;
  margin-bottom: 10px;
}
img:active {
  transform: scaleY(0.95);
}
.fa-chevron-right {
  opacity: 0.7;
}
.main-list {
  overflow: scroll;
  max-height: calc(100vh - 110px);
  width: 100px;
  /* margin-top: 20px; */
  text-align: center;
}
.main-list div {
  margin-top: 20px;
}
</style>